<div class="container">
  <div class="title">
    <span class="h3">{{ 'DATA.DOWNLOAD.WHAT_TO_DO' | translate }}?</span>
    <button class="btn-empty" (click)="close()">
      <svg [icon]="icons.Close" class="close-icon dark-gray-color svg24" />
    </button>
  </div>

  <div class="body mt20">
    <ng-container *ngIf="isDynamic; then dynamicCatalog; else staticCatalog"></ng-container>


    <div class="horizontal-line mt16 mb12"></div>

    <app-favorites-and-subscribe-catalog [isDynamic]="isDynamic" [catalogId]="catalogId" ></app-favorites-and-subscribe-catalog>
  </div>
</div>


<ng-template #staticCatalog>
  <span class="overline-2 inactive-color mt12">{{ 'DATA.DOWNLOAD.EXPORT_DATA_SET' | translate }} </span>


  <button (click)="downloadFile($event, file)" *ngFor="let file of filesTypes" class="btn-empty btn-with-icon mt12">
    <svg [ngClass]="{'loading-icon': file.idFile && file.status === 'PROCESSING'}" [icon]=" !file.idFile ? icons.AddPlus : file.idFile && file.status === 'PROCESSING' ? icons.Loading : icons.Downloaded" class="svg24 mr12 dark-gray-color" />
    <span class="h4 mr4"> {{ file.format }} </span>
    <span *ngIf="file.idFile && file.status === 'SUCCESS'" class="body-2"> ({{'OTHER.ARCH' | translate}} zip: {{ file.archiveFileSize + ' kb' }}) </span>
  </button>



  <button class="btn-empty btn-with-icon mt12" [routerLink]="'/developers/useApi'" [queryParams]="{geoJson: catalogId}">
    <svg [icon]="icons.Downloaded" class="svg24 mr12 dark-gray-color" />
    <span class="h4 mr4"> geojson </span>
    <span> ({{ 'DATA.DOWNLOAD.ONLY_AVAILABLE_VIA_API' | translate }}) </span>
  </button>

  <ng-container *ngTemplateOutlet="passport"></ng-container>

</ng-template>


<ng-template #dynamicCatalog>

  <button (click)="openHistoricalDataModal()" matTooltip="{{'DATA.DOWNLOAD_HISTORICAL_DATA_TOOLTIP'| translate }}"  class="btn-empty btn-with-icon dark-gray-color" >
    <svg [icon]="icons.Downloaded" class="svg24 mr12" />
    <span class="body-1"> {{'DATA.DOWNLOAD_HISTORICAL_DATA'| translate }}  </span>
  </button>

<ng-container *ngTemplateOutlet="passport"></ng-container>

</ng-template>


<ng-template #passport>
  <div class="mt12">
    <span class="overline-2 inactive-color">{{ 'DATA.DOWNLOAD.EXPORT_PASSPORT' | translate }}</span>
  </div>
  <button (click)="downloadPasport('json')" class="btn-empty btn-with-icon mt12">
    <svg [icon]="icons.Downloaded" class="svg24 mr12 dark-gray-color" />
    <span class="h4"> json </span>
  </button>

  <button  (click)="downloadPasport('csv')" class="btn-empty btn-with-icon mt12">
    <svg [icon]="icons.Downloaded" class="svg24 mr12 dark-gray-color" />
    <span class="h4"> csv </span>
  </button>
</ng-template>
